import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialog } from "primeng/confirmdialog";

@Component({
  imports: [RouterOutlet, ToastModule, ConfirmDialog],
  selector: 'app-root',
  template: `
    <p-toast></p-toast>
    <p-confirmDialog></p-confirmDialog>
    <router-outlet></router-outlet>
  `,
  styles: [`
    :host {
      display: block;
    }
  `]
})
export class App {
  protected title = 'MiApp';
}
